export default __webpack_public_path__ + "static/media/menu-icon.f99af37b.svg";